function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import Button from '@profile/src/Components/Button_V2';
import Modal from '@profile/src/Components/PopupModal_V2';
import icThetan from 'assets/img/thetan_logo_V2.png';
import { authenticateUser, updateWalletBalance } from '@profile/src/redux/actions';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import { logConnectWalletEvent } from '@profile/src/utils/analytic';
import { getAuthNonce, putWalletConnect } from '@profile/src/redux/api';
import noop from 'lodash/noop';
import { useTestId } from '@wolffun/testable-id';

const AcceptAndSignModal = ({
  onClose,
  onError,
  provider: selectedProvider
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const dispatch = useTypedDispatch();
  const account = useTypedSelector(state => {
    var _state$connectWallet$;

    return (_state$connectWallet$ = state.connectWallet.accounts) === null || _state$connectWallet$ === void 0 ? void 0 : _state$connectWallet$[0];
  });
  const [nonce, setNonce] = React.useState('');
  React.useEffect(() => {
    const fetch = async () => {
      if (account) {
        const nonceResponse = await getAuthNonce({
          Address: account
        });

        if (nonceResponse.status === 'ok') {
          setNonce(nonceResponse.body.nonce.toString());
        }
      }
    };

    fetch();
  }, [account]);
  const getUserSignature = React.useCallback(async () => {
    const user = await dispatch(authenticateUser(nonce));

    if (!user) {
      onError();
      return;
    }

    const {
      thetaBalance,
      thgBalance
    } = await dispatch(updateWalletBalance());

    if (user && thetaBalance && thgBalance) {
      logConnectWalletEvent({
        THC: thetaBalance,
        THG: thgBalance,
        userId: user.id,
        email: user.email,
        walletAddress: user.address,
        provider: selectedProvider || ''
      });
      putWalletConnect({
        walletType: selectedProvider ?? 'Unknown'
      }).catch(noop);
    }
  }, [dispatch, nonce, selectedProvider]);
  return /*#__PURE__*/React.createElement(Modal, _extends({}, generateTestIdProps('close'), {
    onClose: onClose
  }), /*#__PURE__*/React.createElement("img", {
    src: icThetan,
    alt: "thetan-logo",
    className: styles.logo
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Welcome to Thetan Arena"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, "By Connecting your wallet and using Thetan Arena, you agree to our\xA0", /*#__PURE__*/React.createElement("a", {
    href: "https://doc.thetanarena.com/faqs/terms-of-use",
    rel: "noreferrer",
    target: "_blank"
  }, "Terms of Service"), "\xA0and\xA0", /*#__PURE__*/React.createElement("a", {
    href: "https://doc.thetanarena.com/faqs/policy",
    target: "_blank",
    rel: "noreferrer"
  }, "Privacy Policy"), "."), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, _extends({
    type: "outlined",
    onClick: () => {
      onClose();
    },
    className: styles.btnCancel,
    title: "Cancel"
  }, generateTestIdProps('cancel'))), /*#__PURE__*/React.createElement(Button, _extends({
    onClick: () => {
      getUserSignature();
      onClose();
    },
    className: styles.btn,
    title: "Accept and sign"
  }, generateTestIdProps('accept-and-sign')))));
};

export default AcceptAndSignModal;